<script>
import Page from '@/components/elements/Page';
import PageIntro from '@/components/elements/PageIntro';
import CcButton from '@/components/elements/CcButton';

export default {
    name: 'RecoveryNotPossible',
    components: { Page, PageIntro, CcButton },
    computed: {
        recoveryExpirationDays() {
            return this.$store.state.holderConfig.recoveryExpirationDays;
        }
    },
    methods: {
        goHome() {
            this.$router.push({ name: 'Home' })
        }
    }
}
</script>

<template>
    <Page
        :display-back-button="false">
        <div class="section">
            <PageIntro
                :head="$t('views.recoveryNotPossible.pageHeader')"
                :intro="$t('views.recoveryNotPossible.pageIntro')"/>
            <div class="section-block">
                <div class="section-block__footer">
                    <CcButton
                        @select="goHome()"
                        :label="$t('goBackToStart')"/>
                </div>
            </div>
        </div>
    </Page>
</template>
